<template>
    <svg class="mark mark--scale" viewBox="0 0 100 100" overflow="visible" data-mark="rocker" aria-hidden="true">
        <rect class="rocker__diamond" x="39.75" y="63.75" width="20.5" height="20.5" rx="2" transform="rotate(45 50 74)" />
        <path class="pop__dome" d="M 26 59.5 A 24 24 0 0 1 74 59.5 Z" />
        <circle class="paddle__ball" cx="50" cy="28.5" r="7" />
    </svg>
</template>

<script setup lang="ts"></script>

<style scoped>
@reference "../../../../css/tailwind.css";

@layer components {
    .mark {
        @apply block size-full overflow-visible;
    }

    .mark--scale {
        @apply scale-125;
        transform-origin: 50% 50%;
    }

    .rocker__diamond {
        fill: var(--tonal-purple-base);
    }

    .pop__dome {
        fill: var(--tonal-pink-strong);
        transform-box: fill-box;
        transform-origin: 50% 100%;
        animation: pop-dome 1.1s infinite;
    }

    .paddle__ball {
        fill: var(--tonal-orange-strong);
        transform-box: fill-box;
        transform-origin: 50% 100%;
        animation: paddle-ball 1.1s infinite;
    }
}

@keyframes paddle-ball {
    0% {
        transform: translateY(0) scale(1.18, 0.8);
        animation-timing-function: ease-out;
    }

    7% {
        transform: translateY(-6px) scale(1, 1);
        animation-timing-function: cubic-bezier(0.1, 0.6, 0.45, 1);
    }

    50% {
        transform: translateY(-30px) scale(1, 1);
        animation-timing-function: cubic-bezier(0.55, 0, 0.9, 0.4);
    }

    93% {
        transform: translateY(-6px) scale(1, 1);
        animation-timing-function: ease-in;
    }

    100% {
        transform: translateY(0) scale(1.18, 0.8);
    }
}

@keyframes pop-dome {
    0% {
        transform: scale(1.1, 0.86);
    }

    10% {
        transform: scale(0.97, 1.05);
    }

    20% {
        transform: scale(1.01, 0.99);
    }

    30%,
    92% {
        transform: scale(1, 1);
    }

    100% {
        transform: scale(1.1, 0.86);
    }
}

@media (prefers-reduced-motion: reduce) {
    .paddle__ball,
    .pop__dome {
        animation: none;
    }
}
</style>
